import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const PromotionListPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Promociones</h2>
          <p>Listado general de promociones configuradas.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PromotionListPage;
